/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Rail_AudienceInputs */

const en_directory_detail_rail_audience = /** @type {(inputs: Directory_Detail_Rail_AudienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target audience`)
};

const zh_directory_detail_rail_audience = /** @type {(inputs: Directory_Detail_Rail_AudienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标受众`)
};

/**
* | output |
* | --- |
* | "Target audience" |
*
* @param {Directory_Detail_Rail_AudienceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_rail_audience = /** @type {((inputs?: Directory_Detail_Rail_AudienceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Rail_AudienceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_rail_audience(inputs)
	return zh_directory_detail_rail_audience(inputs)
});
export { directory_detail_rail_audience as "directory.detail.rail.audience" }